import React from "react";
import styled from "styled-components";
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import PropTypes from "prop-types";

const MultipleDropdownSelect = ({
                                  direction = "right",
                                  defaultOpen = false,
                                  options,
                                  onChange,
                                  children,
                                  isArrow = true,
                                  style,
                                  className,
                                  styleList,
  custom = false,
                                  clear = false,
                                  search = false
                                }) => {

  const [isOpen, setIsOpen] = React.useState(defaultOpen);
  const [data, setData] = React.useState(options || [])

  React.useEffect(() => {
    setData(options)
  }, [options])

  const changeByKey = (key, checked) => options.map((item) => item.key !== key ? ({ ...item }) : ({
    ...item,
    checked
  }));

  const handleChangeCheckbox = (key, checked) => {
    onChange(changeByKey(key, checked), key, checked);
  };

  const onClear = () => {
    onChange(options.map(i => ({ ...i, checked: false })));
  };

  const toggle = () => {
    setData(options)
    setIsOpen(prev => !prev)
  }

  return (
    <MultipleDropdownSelectStyled
      isOpen={isOpen}
      direction={direction}
      className={"dropdown-menu-end " + className}
      toggle={toggle}
      style={style}
    >
      {custom ? children : <DropdownToggle className="btn btn-secondary dropdown-btn-hidden-columns" caret>
        {/*Dropdown button{" "}*/}
        {/*<i className="bx bx-menu" />*/}
        {children}
        {isArrow && <i className="mdi mdi-chevron-down" />}
      </DropdownToggle>}
      <DropdownMenu className="dropdown-menu-end" style={styleList}>
        {clear && <DropdownItem className="btn-clear-dropdown-list" onClick={onClear}>Clear</DropdownItem>}
        {search && <div
          className={`d-block pointer-event dropdown-search-field ${clear ? "dropdown-checkbox-item__is-clear" : ""}`}>
          <label
            htmlFor="search-bar-0"
            className="search-label"
          >
            <input
              id="search-bar-0"
              type="text"
              aria-labelledby="search-bar-0-label"
              className="form-control"
              onChange={e => setData(options.filter(i => i.text.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1))}
              placeholder="Search"
            />
          </label>
        </div>}
        {data.map(({ key, text, checked }) => (
          <label key={key}
                 className={`d-block pointer-event dropdown-item form-check-label ${clear ? "dropdown-checkbox-item__is-clear" : ""}`}
                 htmlFor={key + "item"}>
            <input
              className="form-check-input"
              type="checkbox"
              // value=""
              checked={checked}
              onChange={e => handleChangeCheckbox(key, e.target.checked)}
              style={{ marginRight: 10 }}
              id={key + "item"}
            />
            <label
              className="form-check-label"
              htmlFor={key + "item"}
            >
              {text}
            </label>
          </label>
        ))}
      </DropdownMenu>
    </MultipleDropdownSelectStyled>
  );
};

MultipleDropdownSelect.propTypes = {
  direction: PropTypes.string,
  defaultOpen: PropTypes.bool,
  options: PropTypes.any,
  onChange: PropTypes.func,
  children: PropTypes.any,
  isArrow: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  styleList: PropTypes.object,
  clear: PropTypes.bool,
  search: PropTypes.bool,
  custom: PropTypes.bool,
};

const MultipleDropdownSelectStyled = styled(ButtonDropdown)`
  .dropdown-checkbox-item__is-clear {
    position: relative;
    top: -32px;
  }

  .dropdown-search-field {
    padding: 0.35rem 1.5rem;
  }

  .btn-clear-dropdown-list {
    text-align: center;
    height: 40px;
    cursor: pointer;
    background-color: #556ee6;
    color: #fff;
    margin-bottom: -10px;
    position: sticky;
    top: calc(100% - 32px);
    z-index: 2;
  }
`;

export default (MultipleDropdownSelect);
